// src/components/alerts/AlertFiltersBar.js
// --- UPDATE (Alert System AI) — NEW: one filter bar for alerts and rules (was two copies inline
// in the page). Search shows a spinner while the debounce is pending; active filters can be
// cleared in one click.
import React from 'react';
import PropTypes from 'prop-types';
import {
    Box, Button, Flex, Icon, Input, InputGroup, InputLeftElement, Select, Spinner, useColorModeValue,
} from '@chakra-ui/react';
import { MdSearch, MdFilterAltOff } from 'react-icons/md';

function AlertFiltersBar({ search, onSearch, isSearching, placeholder, selects, values, onSelectChange, onClear, children }) {
    const bg = useColorModeValue('gray.50', 'gray.900');
    const border = useColorModeValue('gray.200', 'gray.700');
    const inputBg = useColorModeValue('white', 'gray.800');
    const hasFilters = !!search || selects.some(s => values[s.name] !== '' && values[s.name] !== undefined);
    return (
        <Box bg={bg} p={3} borderRadius="xl" borderWidth="1px" borderColor={border} mb={4}>
            <Flex gap={3} flexWrap="wrap" align="center">
                <InputGroup flex="1" minW="220px">
                    <InputLeftElement pointerEvents="none">
                        {isSearching ? <Spinner size="sm" color="blue.400" /> : <Icon as={MdSearch} color="gray.400" />}
                    </InputLeftElement>
                    <Input placeholder={placeholder} value={search} onChange={e => onSearch(e.target.value)} bg={inputBg} borderRadius="lg" aria-label={placeholder} />
                </InputGroup>
                {selects.map(s => (
                    <Select key={s.name} aria-label={s.placeholder} value={values[s.name] ?? ''} onChange={e => onSelectChange(s.name, e.target.value)}
                        maxW={s.maxW || '170px'} bg={inputBg} borderRadius="lg">
                        <option value="">{s.placeholder}: all</option>
                        {s.options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </Select>
                ))}
                {hasFilters && onClear && (
                    <Button size="sm" variant="ghost" leftIcon={<MdFilterAltOff />} onClick={onClear}>Clear</Button>
                )}
                {children}
            </Flex>
        </Box>
    );
}

AlertFiltersBar.propTypes = {
    search: PropTypes.string,
    onSearch: PropTypes.func.isRequired,
    isSearching: PropTypes.bool,
    placeholder: PropTypes.string,
    selects: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string, placeholder: PropTypes.string, options: PropTypes.array, maxW: PropTypes.string })),
    values: PropTypes.object,
    onSelectChange: PropTypes.func.isRequired,
    onClear: PropTypes.func,
    children: PropTypes.node,
};
AlertFiltersBar.defaultProps = { search: '', placeholder: 'Search…', selects: [], values: {} };

export default React.memo(AlertFiltersBar);
// --- END UPDATE
